import { render, staticRenderFns } from "./VerifyEmailToken.vue?vue&type=template&id=6e3ed96a&"
import script from "./VerifyEmailToken.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports